import _defineProperty from "/home/prasanta/Projects/get-mutual-transfer-website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import { Urls } from "../../../../util/constant";
import CategoryIcons from "../../../atoms/CategoryIcons/CategoryIcons";
import { ShallowLink } from "../../../atoms/LinkBtn/LinkBtn";
import styles from "./CategoryCardBtn.module.css";
export function getLabelFromImg(img) {
  switch (img) {
    case "PRIMARY_SCHOOL":
      return "Primary School";

    case "NON_TEACHING_STAFF":
      return "Non Teaching Staff";

    case "POSTAL_STAFF":
      return "Postal Staff";

    case "RAILWAY_STAFF":
      return "Railway Staff";

    case "COLLAGE_STAFF":
      return "College/University";

    case "HIGH_SCHOOL":
    default:
      return "High School";
  }
}

var convertCategoryToUrl = function convertCategoryToUrl(category) {
  switch (category) {
    case "HIGH_SCHOOL":
      return Urls.HIGH_SCHOOL_URL;

    case "PRIMARY_SCHOOL":
      return Urls.PRIMARY_SCHOOL_URL;

    case "NON_TEACHING_STAFF":
      return Urls.NON_TEACHING_STAFF_URL;

    case "POSTAL_STAFF":
      return Urls.POSTAL_STAFF_URL;

    case "RAILWAY_STAFF":
      return Urls.RAILWAY_STAFF_URL;

    case "COLLAGE_STAFF":
      return Urls.COLLAGE_STAFF_URL;

    default:
      return "";
  }
};

export default function CategoryCardBtn(_ref) {
  var img = _ref.img,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return null;
  } : _ref$onClick,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected;
  return /*#__PURE__*/_jsx("div", {
    className: [styles.category_card_btn, selected && styles.selected].join(" "),
    "data-cy": img,
    children: /*#__PURE__*/_jsxs(ShallowLink, {
      href: convertCategoryToUrl(img),
      children: [/*#__PURE__*/_jsx(CategoryIcons, {
        img: img,
        height: 120,
        width: 120
      }), /*#__PURE__*/_jsx("span", {
        style: {
          width: 110
        },
        className: styles.category_card_btn__label,
        children: getLabelFromImg(img)
      })]
    })
  });
}

var chooseSize = function chooseSize(size) {
  switch (size) {
    case "sm":
      return 64;

    case "regular":
    default:
      return 120;
  }
};

export function CategoryCardRadio(_ref2) {
  var category = _ref2.category,
      selectedCategory = _ref2.selectedCategory,
      rest = _ref2.rest,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "regular" : _ref2$size;
  var selected = selectedCategory === category;

  var _size = chooseSize(size);

  return /*#__PURE__*/_jsxs("label", {
    htmlFor: category,
    className: [styles.category_card_btn, selected && styles.selected, size === "sm" && styles.sm].join(" "),
    children: [/*#__PURE__*/_jsx(CategoryIcons, {
      img: category,
      height: _size,
      width: _size
    }), /*#__PURE__*/_jsx("span", {
      style: {
        width: 110
      },
      className: styles.category_card_btn__label,
      children: getLabelFromImg(category)
    }), /*#__PURE__*/_jsx("input", _objectSpread({
      type: "radio",
      id: category,
      value: category,
      className: styles.hidden
    }, rest))]
  });
}